import React, { Component, Fragment } from "react"
import { Link } from "react-router-dom"
import CheckoutBillingInformation from "./checkoutBillingInformation"
import CheckoutVechicleInformation from "./checkoutVechicleInformation"
import CheckoutRefund from "./checkoutRefund"
import CheckoutConsent from "./checkoutConsent"
import config from "react-global-configuration"
import * as endpoint from "../../constants/Endpoints"
import CheckoutCompareBookings from "./checkoutCompareBookings"
import * as path from "../../constants/Paths"
import * as cookieNames from "../../constants/Cookies"
import * as tracking from "../../helpers/tracking"
import * as cookieHelper from "../../../helpers/cookie"
import { Forms } from "../../../styleguide/js/components/forms"
import CheckoutSummaryUpgradeOfferApproval from "./checkoutSummaryUpgradeOfferApproval"
import Map from "../Map/map"
import { emailValidatingRegex, hostnameValidatingRegex } from "../BookingJourney"
import CheckoutExtendBookings from "./checkoutExtendBookings"

class Checkout extends Component {
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
    this.state = {
      isTracked: false,
    }
  }

  componentDidMount() {
    window.addEventListener("message", this.messageListener)
    window.addEventListener("popstate", () => this.props.closePaymentModal())
    new Forms({ el: this.containerRef.current })
    this.updateRequiredFields(true)

    if (
      !this.props.isAmendment &&
      !this.state.isTracked &&
      !this.props.cookies.get(cookieNames.ACCESS_TOKEN) &&
      this.props.bookingResult &&
      !this.props.bookingExtension
    ) {
      tracking.trackPageView(
        this.props,
        "parking checkout",
        "/virtual/(|en/|sv/)parkering/search/checkout" + `${this.props.useNewDesign ? "?newDesign=true" : ""}`,
      )
      tracking.trackParkingInteraction(this.props, "begin_checkout")
      this.trackSelectedExtraServices()
      this.setState({ isTracked: true })
    }
    //disables form submit on Enter
    if (document.getElementById("parkingCheckoutForm")) {
      document.getElementById("parkingCheckoutForm").onkeypress = function (e) {
        var key = e.charCode || e.keyCode || 0
        if (key === 13) {
          e.preventDefault()
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.bookingResult && this.props.bookingResult) {
      this.updateRequiredFields(true)
    }
    if (prevProps.bookingResult && !this.props.bookingExtension) {
      if (prevProps.bookingResult.activeBookingExtraProducts.length !== this.props.bookingResult.activeBookingExtraProducts.length) {
        this.updateRequiredFields()
      }
    }

    if (this.props.checkoutErrors.showErrors) {
      const firstErrorElement = document.querySelectorAll(".is-invalid")[0]
      const isIE11 = !!window.MSInputMethodContext && !!document.documentMode
      const isEdge = navigator.userAgent.indexOf("Edge") >= 0
      let scrollOptions = {
        behavior: "smooth",
        block: "center",
      }
      if (isIE11 || isEdge) {
        scrollOptions = { behavior: "smooth" }
      }

      if ((isEdge || isIE11) && firstErrorElement) window.scrollTo({ top: firstErrorElement.offsetTop, behavior: "smooth" })
      else firstErrorElement?.scrollIntoView(scrollOptions)
    }
    const { userAccountDetails } = this.props
    if (prevProps.userAccountDetails !== userAccountDetails) {
      this.updateRequiredFields()
    }
    if (
      !this.props.isAmendement &&
      !this.state.isTracked &&
      this.props.userAccountDetails &&
      this.props.bookingResult &&
      !this.props.bookingExtension
    ) {
      tracking.trackPageView(
        this.props,
        "parking checkout",
        "/virtual/(|en/|sv/)parkering/search/checkout" + `${this.props.useNewDesign ? "?newDesign=true" : ""}`,
      )
      tracking.trackParkingInteraction(this.props, "begin_checkout")
      this.trackSelectedExtraServices()
      this.setState({ isTracked: true })
    }
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.messageListener)
  }

  messageListener = (messageEvent) => {
    if (messageEvent.origin === "https://v1.checkout.bambora.com") {
      const { event, payload } = messageEvent.data
      switch (event) {
        case "cancel":
          this.props.paymentModalHide()
          break
        case "paymentTypeSelection":
          this.props.handleSelectedPaymentType(payload)
          break

        case "cardTypeResolve":
          this.props.handleSelectedPaymentType(payload)
          break

        case "authorize":
          // this should call the reidrect url from the backend
          tracking.trackOrderComplete(this.props, this.props.useNewDesign)
          if (this.props.upsaleTrackingData) {
            tracking.trackParkingProductUpgrade(this.props, this.props.upsaleTrackingData, "purchase")
          }
          break
        case "ready":
          // callback url has responded
          // user is shown the option to store Creditcard with Bambora here
          // timer here can be set on CreatePaymentSessionInBackend

          // TODO: at this point the payment has been submitted, so here we should start polling
          // TODO decide what should happen if booking is comleted before user has decided wether or not to store his card
          break
        case "close":
          // user pressed close button
          this.props.paymentModalHide()

          // force reload to get latest boooking from server so it has qr code
          window.location.assign(`${path.RECEIPT()}?bguid=${this.props.bookingResult.booking.guid}`)

          // open receipt page here
          // this.props.history.push({ pathname: path.RECEIPT(), search: `?bguid=${this.props.bookingResult.booking.guid}` })
          break
        default:
          console.log("unknown data.event: " + event)
      }
    } else if (messageEvent.origin === window.location.protocol + endpoint.hosts().PARKING_BASE_URL) {
      console.debug("Parking Service event")
      console.debug(messageEvent.data)
      if (messageEvent.data.indexOf("reason=") === -1) {
        // success, tell the datalayer
        this.props.setReceiptShouldTrack(true)
      }
      this.props.paymentModalHide()
      this.props.history.push({ pathname: path.prefix() + messageEvent.data.split("?")[0], search: messageEvent.data.split("?")[1] })
    } else {
      // console.log("unknown event")
      // console.log(messageEvent)
    }
  }

  trackSelectedExtraServices = () => {
    const { booking, activeBookingExtraProducts } = this.props.bookingResult
    if (activeBookingExtraProducts) {
      if (activeBookingExtraProducts.length > 0 && !this.props.bookingExtension) {
        const label = `${activeBookingExtraProducts[0].product.name} ${activeBookingExtraProducts[0].variants[0].productOffer.name}`
        const userId = cookieHelper.getUserId(this.props)
        const data = {
          event: "track-event",
          eventCategory: "parking flow",
          eventAction: "options - extra services",
          eventLabel: label,
          eventValue: activeBookingExtraProducts[0].variants[0].priceOffer.amount,

          userParkingArrivalDate: booking.arrivalDate,
          userParkingDepartureDate: booking.departureDate,
          pageBusinessunit: "parking",
          logged_in: cookieHelper.isLoggedIn(),
        }
        if (userId) data.userId = userId
        window.dataLayer.push(data)
      }
    }
  }

  getRequiredFields = (initial = false) => {
    const { booking } = this.props.bookingResult
    const hideFields = config.get("textKeys.checkout.hideBillingFields") || {}
    //        const { checkoutErrors } = this.props
    const { vechicleInformation: currentVechicleInformation, billingAddress: currentBillingAddress } = this.props
    const isVehicleRegistrationNumberRequired = !!(
      booking &&
      booking.overrideFields &&
      booking.overrideFields.find((e) => e.fieldName === "VehicleRegistrationNumber" && e.mandatory === true)
    )
    const isVehicleMakeRequired = !!(
      booking &&
      booking.overrideFields &&
      booking.overrideFields.find((e) => e.fieldName === "VehicleMake" && e.mandatory === true)
    )
    const isVehicleModelRequired = !!(
      booking &&
      booking.overrideFields &&
      booking.overrideFields.find((e) => e.fieldName === "VehicleModel" && e.mandatory === true)
    )
    const isVehicleColourRequired = !!(
      booking &&
      booking.overrideFields &&
      booking.overrideFields.find((e) => e.fieldName === "VehicleColour" && e.mandatory === true)
    )
    const vechicleInformation = {
      vehicleRegistrationNumber:
        currentVechicleInformation.vehicleRegistrationNumber && currentVechicleInformation.vehicleRegistrationNumber.length > 0
          ? false
          : isVehicleRegistrationNumberRequired,
      vehicleMake: currentVechicleInformation.vehicleMake && currentVechicleInformation.vehicleMake.length > 0 ? false : isVehicleMakeRequired,
      vehicleModel: currentVechicleInformation.vehicleModel && currentVechicleInformation.vehicleModel.length > 0 ? false : isVehicleModelRequired,
      vehicleColour:
        currentVechicleInformation.vehicleColour && currentVechicleInformation.vehicleColour.length > 0 ? false : isVehicleColourRequired,
    }

    let fields = vechicleInformation
    const billingAddress = {
      firstName: currentBillingAddress.firstName && currentBillingAddress.firstName.length > 0 ? false : true,
      lastName: currentBillingAddress.lastName && currentBillingAddress.lastName.length > 0 ? false : true,
      postcode: hideFields?.hidePostcode || (currentBillingAddress.postcode && currentBillingAddress.postcode.length > 0) ? false : true,
      town: hideFields?.hideCity || (currentBillingAddress.town && currentBillingAddress.town.length > 0) ? false : true,
      email: !this.validateEmail(currentBillingAddress.email),
      mobilePhone: currentBillingAddress.mobilePhone && currentBillingAddress.mobilePhone.length > 0 ? false : true,
    }

    const consentErrors = {}
    this.props.consentContent.items.forEach((item) => {
      if (item.isRequired) {
        const isSelected = this.props.consentInformation[item.consentId]
        consentErrors[item.consentId] = !isSelected
      }
    })
    fields = { ...fields, ...billingAddress, ...consentErrors }
    return fields
  }

  validateEmail = (email) => {
    if (!(email && email.length > 0)) return false

    if (!emailValidatingRegex.test(email)) return false

    const hostnamePostion = email.lastIndexOf("@")
    if (hostnamePostion === -1) return false

    const hostname = email.substr(hostnamePostion + 1)
    return hostnameValidatingRegex.test(hostname)
  }

  updateRequiredFields = (initial = false) => {
    this.props.updateCheckoutErrorsRequiredFields(this.getRequiredFields())
  }

  validateFields = () => {
    const { checkoutErrors } = this.props
    const errors = Object.keys(checkoutErrors).filter((key) => {
      if (key !== "showErrors" && checkoutErrors[key]) return { [key]: checkoutErrors[key] }
      return null
    })
    return errors.length === 0
  }

  handleHistoryState() {
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: this.props.location.search,
      state: { ...this.state },
    })
  }

  handlePay = (e) => {
    e.preventDefault()
    this.handleHistoryState()
    const { booking, parkingExtension } = this.props.bookingResult
    if (this.validateFields()) {
      this.props.prepareForPayment(booking.guid, parkingExtension?.extensionId)
    } else {
      this.props.updateCheckoutErrorsValues("showErrors", !true)
      return false
    }
  }

  handleMobilePay = (e) => {
    e.preventDefault()
    this.handleHistoryState()
    const { booking, parkingExtension } = this.props.bookingResult
    if (this.validateFields()) {
      this.props.prepareForPaymentMobilePay(booking.guid, parkingExtension?.extensionId)
      this.props.handleSelectedPaymentType("mobilepay")
    } else {
      this.props.updateCheckoutErrorsValues("showErrors", !true)
      return false
    }
  }

  handleBackTracking = () => {
    tracking.trackParkingFlowClick("go back", "step 4", this.props)
  }

  render() {
    if (!this.props.bookingResult && !this.props.bookingExtension) return null
    const listTextKeys = config.get("textKeys.extraServices.list") || {}
    const mainCheckoutTextKeys = config.get("textKeys.checkout.main") || {}
    const amendmentUpgradeTextKeys = config.get("textKeys.amendment.upgrade") || {}
    const textKeyBack = config.get("textKeys.amendment.manage") || {}
    const textKeysExtend = config.get("textKeys.amendment.extend") || {}

    const { booking, modificationSummary, carPark, product, parking } = this.props.bookingResult
    let isUpgrade = !!parking?.parkingUpgrade?.upgradedProductId
    let isAmendement = this.props.isAmendment
    const isNewBooking = !isUpgrade && !isAmendement
    const { checkoutErrors, userAccountDetails } = this.props

    let amountToPay = booking.amountPayable
    if (isUpgrade || isAmendement) {
      amountToPay = modificationSummary?.netChargesForAmendment || 0
    }

    if (this.props.bookingExtension) {
      amountToPay = this.props.bookingExtension.parkingExtension.priceChange
    }

    const upgradeMapProduct = { carPark: carPark, product: product, result: { totalPrice: booking.price } }
    let allProducts = this.props.allProducts?.filter((p) => p.product.code === product.code)
    allProducts = allProducts?.length === 0 ? [upgradeMapProduct] : allProducts

    // let displayName = bookingHelper.getCategoryName(carPark.code || "", product.name || "")

    if (isNewBooking && !this.props.isAmendment) {
      return (
        <React.Fragment>
          <section className="deck deck--white deck--static deck--extra-padding-bottom form form--parking js--parking-form" ref={this.containerRef}>
            <div className={"w--wider"}>
              <form id="parkingCheckoutForm" className={"form form--parking"}>
                {!isUpgrade ? "" : <CheckoutCompareBookings {...this.props} />}
                {/* <CheckoutSummary
                        header={isUpgrade ? `Igangværende booking` : undefined}
                        bookingResult={this.props.bookingResult}
                        parkingTimeModalToogle={this.props.parkingTimeModalToogle}
                        location={this.props.location}
                        createQueryStrings={this.props.createQueryStrings}
                    /> */}
                <CheckoutBillingInformation
                  {...this.props}
                  checkoutErrors={checkoutErrors}
                  getRequiredFields={this.getRequiredFields}
                  userAccountDetails={userAccountDetails}
                  validationMessageReplace={this.props.validationMessageReplace}
                />
                <CheckoutVechicleInformation
                  {...this.props}
                  checkoutErrors={checkoutErrors}
                  getRequiredFields={this.getRequiredFields}
                  validationMessageReplace={this.props.validationMessageReplace}
                />
                {/* <CheckoutFlightInformation checkoutErrors={checkoutErrors} flightInformation={this.props.flightInformation} {...this.props} /> */}

                <CheckoutRefund {...this.props} />
                <CheckoutConsent {...this.props} checkoutErrors={checkoutErrors} getRequiredFields={this.getRequiredFields} />

                <CheckoutSummaryUpgradeOfferApproval
                  {...this.props}
                  header={config.get("textKeys.amendment.manage.header") || "Din reservation"}
                  checkoutErrors={checkoutErrors}
                  getRequiredFields={this.getRequiredFields}
                  content={this.props.content}
                  termsAndConditionsContent={this.props.termsAndConditionsContent}
                  isUpgrade={isUpgrade}
                />

                <div className="form--parking__total">
                  <h3>
                    {mainCheckoutTextKeys.total || "Total"} {this.props.priceFormatter(amountToPay)}
                  </h3>
                  <div className="action-buttons action-buttons--full">
                    {amountToPay > 0 ? (
                      <button className="button button--medium button--discreet button-fluctuation" onClick={(e) => this.handleMobilePay(e)}>
                        <img src="/static/mobilepay.svg" alt="" />
                      </button>
                    ) : (
                      ""
                    )}

                    <button className="button button--medium button--general button-fluctuation" onClick={(e) => this.handlePay(e)}>
                      <span className="text">
                        {amountToPay > 0 ? mainCheckoutTextKeys.pay || "Betal" : mainCheckoutTextKeys.execute || "Gennemfør"}
                      </span>
                    </button>

                    <Link
                      className="link"
                      to={`${this.props.showExtraServicesStep === true ? path.EXTRA_SERVICES() : path.SEARCH()}${this.props.location.search}`}
                      onClick={() => this.handleBackTracking()}
                    >
                      {listTextKeys.back || "Tilbage"}
                    </Link>
                  </div>
                  <figure>
                    <img src="/static/Payment3.svg" alt="" />
                  </figure>
                </div>
              </form>
            </div>
          </section>
        </React.Fragment>
      )
    }

    // extend your stay checkout
    if (window.location.href.includes("extend-checkout")) {
      return (
        <React.Fragment>
          <section className="deck deck--white deck--static deck--extra-padding-bottom form form--parking js--parking-form" ref={this.containerRef}>
            <div className={"w--wider"}>
              <form id="parkingCheckoutForm" className={"form form--parking"}>
                <CheckoutExtendBookings {...this.props} />

                <CheckoutRefund {...this.props} />

                <div className="form--parking__total">
                  {/* <h3>{mainCheckoutTextKeys.total || "Total"} {this.props.priceFormatter(amountToPay)}</h3> */}
                  <div className="action-buttons action-buttons--full">
                    {this.props.bookingExtension ? (
                      <Fragment>
                        {amountToPay > 0 ? (
                          <button className="button button--medium button--discreet button-fluctuation" onClick={(e) => this.handleMobilePay(e)}>
                            <img src="/static/mobilepay.svg" alt="" />
                          </button>
                        ) : null}

                        <button className="button button--medium button--general button-fluctuation" onClick={(e) => this.handlePay(e)}>
                          <span className="text">
                            {amountToPay > 0 ? mainCheckoutTextKeys.pay || "Betal" : mainCheckoutTextKeys.execute || "Gennemfør"}
                          </span>
                        </button>
                      </Fragment>
                    ) : (
                      <h5>
                        {textKeysExtend.sessionEndedText || "Udvidelses-session udløbet - venligst gå tilbage & vælg et nyt udkørselstidspunkt."}
                      </h5>
                    )}

                    <Link className="link" to={`${path.AMMEND_EXTEND_TIME()}${this.props.location.search}`} onClick={() => this.handleBackTracking()}>
                      {textKeyBack.backText || "Tilbage"}
                    </Link>
                  </div>
                  {this.props.bookingExtension ? (
                    <figure>
                      <img src="/static/Payment3.svg" alt="" />
                    </figure>
                  ) : (
                    ""
                  )}
                </div>
              </form>
            </div>
          </section>
        </React.Fragment>
      )
    }

    // ammendment or upgrade checkout
    if (this.props.isAmendment || this.props.changeFromBooking) {
      let changeFromCarpark
      let bookingResultCarpark = this.props.bookingResult.carPark.id
      if (this.props.changeFromBooking) {
        changeFromCarpark = this.props.changeFromBooking.carPark.id
      }

      return (
        <React.Fragment>
          <section className="deck deck--white deck--static deck--extra-padding-bottom form form--parking js--parking-form" ref={this.containerRef}>
            <div className={"w--wider"}>
              {isUpgrade ? (
                <div className={"upgrade-section"}>
                  {amendmentUpgradeTextKeys.subHeader && !!this.props.bookingResult.parking?.upgradedItem ? (
                    <h3
                      className={"sub-header"}
                      dangerouslySetInnerHTML={{
                        __html: amendmentUpgradeTextKeys.subHeader
                          ?.replace("{carpark}", this.props.bookingResult?.carPark.name)
                          .replace("{upgrade_total}", this.props.priceFormatter(amountToPay))
                          .replace("{display_name}", this.props.bookingResult?.product.name),
                      }}
                    ></h3>
                  ) : (
                    ""
                  )}
                  {amendmentUpgradeTextKeys.calculationInformation ? (
                    <div
                      className="article__box rich-text"
                      dangerouslySetInnerHTML={{
                        __html: amendmentUpgradeTextKeys.calculationInformation
                          ?.replace("{price_difference}", this.props.priceFormatter(modificationSummary.netChargesForAmendment))
                          .replace("{original_carpark}", this.props.changeFromBooking?.carPark.name)
                          .replace("{original_price}", this.props.priceFormatter(modificationSummary.originalBookingValue)),
                      }}
                    ></div>
                  ) : (
                    ""
                  )}
                  {amendmentUpgradeTextKeys.mapHeader && !!this.props.bookingResult.parking?.upgradedItem ? (
                    <h3 className={"map-header"}>
                      {amendmentUpgradeTextKeys.mapHeader
                        ?.replace("{carpark}", this.props.bookingResult?.carPark.name)
                        .replace("{display_name}", this.props.bookingResult?.product.name)}
                    </h3>
                  ) : (
                    ""
                  )}
                  <Map
                    {...this.props}
                    {...this.state}
                    disableReservation={true}
                    allProducts={allProducts}
                    setParkingDetailModalState={this.props.setParkingDetailModalState}
                    gaList={this.props.parkingDetailsModalGaList}
                    gaListIndex={this.props.parkingDetailsModalGaListIndex}
                  />
                </div>
              ) : (
                ""
              )}
              <form id="parkingCheckoutForm" className={"form form--parking"}>
                {/* {!isUpgrade ? "" : */}
                <CheckoutCompareBookings {...this.props} />

                <CheckoutRefund {...this.props} />

                <div className="form--parking__total">
                  {/* <h3>{mainCheckoutTextKeys.total || "Total"} {this.props.priceFormatter(amountToPay)}</h3> */}
                  <div className="action-buttons action-buttons--full">
                    {amountToPay > 0 ? (
                      <button className="button button--medium button--discreet button-fluctuation" onClick={(e) => this.handleMobilePay(e)}>
                        <img src="/static/mobilepay.svg" alt="" />
                      </button>
                    ) : (
                      ""
                    )}

                    <button className="button button--medium button--general button-fluctuation" onClick={(e) => this.handlePay(e)}>
                      <span className="text">
                        {amountToPay > 0 ? mainCheckoutTextKeys.pay || "Betal" : mainCheckoutTextKeys.execute || "Gennemfør"}
                      </span>
                    </button>

                    {changeFromCarpark === bookingResultCarpark ? (
                      <Link className="link" to={`${path.AMMEND_EDIT_TIME()}${this.props.location.search}`} onClick={() => this.handleBackTracking()}>
                        {textKeyBack.backText || "Tilbage"}
                      </Link>
                    ) : (
                      <Link
                        className="link"
                        to={`${path.SEARCH_AMMEND_BOOKING()}${this.props.location.search}`}
                        onClick={() => this.handleBackTracking()}
                      >
                        {textKeyBack.backText || "Tilbage"}
                      </Link>
                    )}
                  </div>
                  <figure>
                    <img src="/static/Payment3.svg" alt="" />
                  </figure>
                </div>
              </form>
            </div>
          </section>
        </React.Fragment>
      )
    }
    return ""
  }
}
export default Checkout
